/**
 * @enum - Push status
 */

enum PushStatus
{
    "N/A" = 0,
    Active = 1,
    Stopped = 2
}

export default PushStatus;